import styled from 'styled-components';
import { fonts } from 'styles';

export const Container = styled.section`
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000;
  padding: 88px 56px;
`;

export const Credits = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 668px;
  color: #fff;

  p {
    font-size: 13px;
    line-height: 20px;
    font-family: ${fonts.BentonSansWideBold};
    margin-bottom: 32px;

    &:last-child {
      margin-bottom: 0;
    }

    span {
      font-size: 14px;
      font-family: ${fonts.BentonSansRegular};
    }
  }
`;

export const Headline2 = styled.h2`
  font-family: ${fonts.BentonSansWideBold};
  font-size: 16px;
  text-transform: uppercase;
  padding-bottom: 16px;
  margin-bottom: 40px;
  border-bottom: 1px solid #ffffff;
`;

export const Wrapper = styled.div`
  display: flex;
  gap: 116px;
`;

export const Column = styled.div``;
